export default {
  bindings: {
    naturalPerson: '<',
  },
  controller: [function () {}],
  templateUrl:
    '/features/modules/shareholders-id/modules/common/components/sid-response-natural-person-info/sid-response-natural-person-info.template.html',
};
